<template>
  <PmSidebarSectionPure
    class="PmSidebarCalendarEvents"
    title="Termine"
    :can-be-collapsed="true"
    :collapsed="collapsableArea.isCollapsed.value"
    @expand="collapsableArea.expand"
    @collapse="collapsableArea.collapse"
  >
    <div class="PmSidebarCalendarEvents-spacer"></div>
  </PmSidebarSectionPure>
</template>

<script>
import { useCollapsableArea } from '@/composition/useCollapsableArea'

import PmSidebarSectionPure from '@/components/persoplan/PmSidebarSection/PmSidebarSectionPure.vue'

export default {
  name: 'PmSidebarCalendarEvents',
  components: {
    PmSidebarSectionPure,
  },

  setup() {
    const collapsableArea = useCollapsableArea({ id: 'calendarEvents' })

    return {
      collapsableArea,
    }
  },
}
</script>

<style lang="scss">
.PmSidebarCalendarEvents {
  $block: &;

  &-spacer {
    min-height: calc(var(--calendarEventsHeight) - 41px);
  }
}
</style>
